////// This replicates the storybook button component, but without the app's theme styling.
////// It's necessary for the login screens, which are outside of the app's context hierarchy, so it can't invoke the theme provider.

import React from 'react';
import { makeStyles, Button as MuiButton } from '@material-ui/core';

const useButtonStyles = makeStyles(theme => ({
  button: {
    borderRadius: 4,
    fontWeight: 500,
    textTransform: 'uppercase',
    boxShadow: 'none',
    minHeight: '48px',
    backgroundColor: props => {
      if (props.color === 'primary') return '#e94f37';
      return '#2d3142';
    },
    color: '#ffffff',
    '&:hover': {
      backgroundColor: props => {
        if (props.color === 'primary') return '#d53f28';
        return '#222531';
      },
    },
    '&.Mui-disabled': {
      backgroundColor: 'rgba(0, 0, 0, 0.12)',
      color: 'rgba(0, 0, 0, 0.26)',
    },
  },
}));

function Button(props) {
  const { variant = 'contained', size = 'large', ...other } = props;
  const classes = useButtonStyles(props);
  
  return (
    <MuiButton 
      className={classes.button}
      variant="contained"
      size={size}
      disableElevation
      {...other}
    />
  );
}

export default Button;
